'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import AbondementAddedHistory from '@/Abondement/AbondementAddedHistory'
import AbondementDownload     from '@/Abondement/AbondementDownload'

import _ from 'lodash'

const numeral = window.numeral;

numeral.locale('en');

export default class ECAdminAbondementHistoryPage extends Component
{
	state = { }

	componentWillMount ()
	{
		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let output =
		(
			<Layout history={ props.history }
				page_title="Historique des ajouts d'abondement à votre CE">

				<div className="page-content">

					<HolidaysMessage />

					<AbondementAddedHistory />

					<AbondementDownload />

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}